module.exports = __webpack_public_path__ + "img/25.f82dce91.jpg";